export default __webpack_public_path__ + "static/media/groundnut.8b6cebaa.png";